export default __webpack_public_path__ + "static/media/artline.1da3ecba.png";